import React from 'react'

export const ArrowRightIcon = ({ color = '#AC0AE8', ...props }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.4689 18.0292C13.1829 17.7296 13.1939 17.2548 13.4936 16.9688L18.4252 12.2614L13.4936 7.55387C13.1939 7.26786 13.1829 6.79312 13.4689 6.4935C13.7549 6.19387 14.2296 6.18283 14.5293 6.46884L20.0293 11.7188C20.1775 11.8604 20.2614 12.0564 20.2614 12.2614C20.2614 12.4663 20.1775 12.6623 20.0293 12.8039L14.5293 18.0539C14.2296 18.3399 13.7549 18.3288 13.4689 18.0292Z'
        fill={color}
      />
      <path
        d='M5.01141 12.2614L19.2614 12.2614'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
